
ko.bindingHandlers.generalDropdown = {
    init: function (element, valueAccessor, allBindings, viewModel, context) {
        const el = $(element);
        const areaEl = $(element).find('[data-general-dropdown-area]');

        let isOpen = false;

        el.click(function (e) {
            if (el.has(e.target).length > 0 && areaEl.has(e.target).length == 0) {
                areaEl.show();
                e.stopPropagation();
                e.preventDefault();
                //console.log('STT');
            }

            isOpen = true;
        });

        function close(e) {
            if (isOpen) {
                if (areaEl.has(e.target).length > 0) return;

                console.log('closing', areaEl.has(e.target), e, e.target)

                areaEl.hide();

                isOpen = false;
            }
        }

        window.addEventListener('general-dropdown-close', close);
        window.addEventListener('click', close, { capture: true });

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            window.removeEventListener('general-dropdown-close', close);
            window.removeEventListener('click', close, { capture: true });
        });
    },
    update: function (element, valueAccessor, allBindings, viewModel, context) {
        //console.log('CLOG', ko.unwrap(valueAccessor()));
    }
};